import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../api/apiClient';

function Footer() {
    const [infoPages, setInfoPages] = useState([]);
    const [otherCategories, setOtherCategories] = useState([]);

    useEffect(() => {
        const fetchFooterData = async () => {
            try {
                const infoRes = await apiClient.get('/web-pages/information');
                if (infoRes.data && infoRes.data.success) {
                    setInfoPages(infoRes.data.data);
                }
            } catch (err) {
                console.error("Failed to load information pages for footer:", err);
            }

            try {
                const otherRes = await apiClient.get('/web-pages/other');
                if (otherRes.data && otherRes.data.success) {
                    setOtherCategories(otherRes.data.data);
                }
            } catch (err) {
                console.error("Failed to load other pages for footer:", err);
            }
        };

        fetchFooterData();
    }, []);

    // Fallbacks if database tables are empty/unseeded
    const fallbackCategories = [
        {
            name: "Holidays",
            Pages: [
                "Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai",
                "Kolkata", "Pune", "Ahmedabad", "Jaipur", "Lucknow",
                "Chandigarh", "Surat", "Indore", "Bhopal", "Coimbatore",
                "Visakhapatnam", "Varanasi", "Goa", "Nagpur", "Patna",
                "Ranchi", "Guwahati", "Thiruvananthapuram", "Kochi",
                "Vadodara", "Raipur", "Agra", "Kanpur", "Mysore",
                "Madurai", "Nashik", "Jodhpur", "Udaipur", "Amritsar",
                "Dehradun", "Shimla", "Gwalior", "Jabalpur", "Meerut",
                "Noida", "Faridabad", "Ghaziabad"
            ].map(city => ({ page_title: city, external_link: "#" }))
        },
        {
            name: "Hotels",
            Pages: [
                "Hotels in Delhi", "Hotels in Mumbai", "Hotels in Bangalore",
                "Hotels in Hyderabad", "Hotels in Chennai", "Hotels in Kolkata",
                "Hotels in Pune", "Hotels in Ahmedabad", "Hotels in Jaipur",
                "Hotels in Lucknow", "Hotels in Chandigarh", "Hotels in Surat",
                "Hotels in Indore", "Hotels in Bhopal", "Hotels in Coimbatore",
                "Hotels in Visakhapatnam", "Hotels in Varanasi", "Hotels in Goa",
                "Hotels in Nagpur", "Hotels in Patna", "Hotels in Ranchi",
                "Hotels in Guwahati", "Hotels in Thiruvananthapuram", "Hotels in Kochi",
                "Hotels in Vadodara", "Hotels in Raipur", "Hotels in Agra",
                "Hotels in Kanpur", "Hotels in Mysore", "Hotels in Madurai",
                "Hotels in Nashik", "Hotels in Jodhpur", "Hotels in Udaipur",
                "Hotels in Amritsar", "Hotels in Dehradun", "Hotels in Shimla",
                "Hotels in Gwalior", "Hotels in Jabalpur", "Hotels in Meerut",
                "Hotels in Noida", "Hotels in Faridabad", "Hotels in Ghaziabad"
            ].map(hotel => ({ page_title: hotel, external_link: "#" }))
        },
        {
            name: "Book Cabs",
            Pages: [
                "Nashik", "Jodhpur", "Udaipur", "Amritsar", "Dehradun",
                "Shimla", "Gwalior", "Jabalpur", "Meerut", "Noida",
                "Faridabad", "Ghaziabad", "Delhi", "Mumbai", "Bangalore",
                "Hyderabad", "Chennai", "Kolkata", "Pune", "Ahmedabad",
                "Jaipur", "Lucknow", "Chandigarh", "Surat", "Indore",
                "Bhopal", "Coimbatore", "Visakhapatnam", "Varanasi", "Goa",
                "Nagpur", "Patna", "Ranchi", "Guwahati", "Thiruvananthapuram",
                "Vadodara", "Raipur", "Agra", "Kanpur", "Mysore", "Madurai"
            ].map(city => ({ page_title: city, external_link: "#" }))
        },
        {
            name: "Medical Services in India",
            Pages: [
                "Cancer Treatment", "Cardiac Surgery", "Orthopedic Surgery",
                "Neurosurgery", "Organ Transplants", "Cosmetic Surgery",
                "Ayurvedic Treatments", "Fertility Treatments", "Dental Care",
                "Bariatric Surgery", "Physiotherapy", "Diagnostic Services",
                "General Surgery", "Spinal Surgery", "Eye Care",
                "Wellness Retreats", "Rehabilitation", "Health Checkups",
                "Liver Transplants", "Kidney Care", "Robotic Surgery",
                "Pediatric Care", "ENT Treatments", "Urology",
                "Gastroenterology", "IVF Procedures", "Dermatology",
                "Mental Health Care", "Pulmonology", "Oncology",
                "Holistic Healing", "Yoga Therapy", "Rheumatology",
                "Immunology", "Sports Medicine", "Pain Management"
            ].map(service => ({ page_title: service, external_link: "#" }))
        }
    ];

    const fallbackInfoPages = [
        { page_title: "About Us", slug: "about-us" },
        { page_title: "Customer Support", slug: "customer-support" },
        { page_title: "Privacy Policy", slug: "privacy-policy" },
        { page_title: "Cookie Policy", slug: "cookie-policy" },
        { page_title: "User Agreement", slug: "user-agreement" },
        { page_title: "Terms of Service", slug: "terms-of-service" }
    ];

    // Select either the fetched dynamic other pages/categories or the fallback
    const categoriesToRender = otherCategories && otherCategories.length > 0
        ? otherCategories.filter(cat => cat.Pages && cat.Pages.length > 0)
        : fallbackCategories;

    const infoPagesToRender = infoPages && infoPages.length > 0
        ? infoPages
        : fallbackInfoPages;

    return (
        <div className="site-footer-wrapper">
            <footer className="footer">
                <div className="pb-4 space-top-1 border-top border-gray-33 pt-4 d-none d-md-block">
                    <div className="container">
                        <div className="row justify-content-xl-between">
                            {/* Dynamic Category Sections */}
                            {categoriesToRender.map((category, catIdx) => (
                                <div key={category.id || catIdx} className="col-12 col-lg-12 col-xl-12 dot1 mb-2">
                                    <div className="d-md-flex d-lg-block">
                                        <div className="mb-2 mr-md-7 mr-lg-0">
                                            <h5 className="footer-heading text-capitalize">{category.name}</h5>
                                            <p className="pt-0 mb-0">
                                                {category.Pages && category.Pages.map((page, pageIdx) => (
                                                    <a 
                                                        href={page.external_link} 
                                                        key={page.id || pageIdx} 
                                                        className="footer-span"
                                                        target={page.external_link && page.external_link.startsWith('http') ? "_blank" : undefined}
                                                        rel={page.external_link && page.external_link.startsWith('http') ? "noopener noreferrer" : undefined}
                                                    >
                                                        {page.page_title}
                                                    </a>
                                                ))}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Dynamic Information Pages (More Information Section) */}
                            <div className="col-12 col-lg-12 col-xl-12 dot1 mb-2">
                                <div className="d-md-flex d-lg-block">
                                    <div className="mb-2 mr-md-7 mr-lg-0">
                                        <h5 className="footer-heading">More Information</h5>
                                        <p className="pt-0 mb-0">
                                            {infoPagesToRender.map((page, index) => (
                                                <Link to={`/page/${page.slug}`} key={page.id || index} className="footer-span">
                                                    {page.page_title}
                                                </Link>
                                            ))}
                                            <Link to="/blogs" className="footer-span">Blogs</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="copyright-sec">
                    <div className="container">
                        <div className="d-lg-flex text-center d-md-block justify-content-center align-items-center">
                            <div className="copyright">
                                Copyright © 2015-{new Date().getFullYear()} Mangoloops. All rights reserved.
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </div>
    );
}

export default Footer;
